import React, { useEffect, useRef, useState } from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Button,
  Table,
  Badge,
  Spinner,
} from "reactstrap";

import axiosConfig from "../../AxiosConfig";

import swal from "sweetalert";

export default function ProductionSteps() {

  const dropdownRef = useRef();

  const user = JSON.parse(
    localStorage.getItem("userData")
  );

  // =====================================
  // STATES
  // =====================================

  const [loading, setLoading] =
    useState(false);

  const [dropdownOpen, setDropdownOpen] =
    useState(false);

  const [allProducts, setAllProducts] =
    useState([]);

  const [selectedProducts, setSelectedProducts] =
    useState([]);

  const [tableData, setTableData] =
    useState([]);

  // =====================================
  // FORM
  // =====================================

  const [form, setForm] = useState({
    processName: "",
    note: "",
    step_Name: "",
    step_No: "",
  });

  // =====================================
  // FETCH PRODUCTS
  // =====================================

  const fetchProducts = async () => {

    try {

      const res =
        await axiosConfig.get(
          `/product/view-product-purchase/${user?.database}`
        );

      setAllProducts(
        res?.data?.Product || []
      );

    } catch (err) {

      console.log(err);

    }
  };

  // =====================================
  // FETCH STEPS
  // =====================================

  const fetchProductionSteps =
    async () => {

      try {
        const res =
          await axiosConfig.get(
            `/production-step/view-steps/${user?._id}`
          );
        setTableData(
          res?.data?.steps || []
        );

      } catch (err) {

        console.log(err);

      }
    };

  // =====================================
  // INITIAL LOAD
  // =====================================

  useEffect(() => {

    fetchProducts();

    fetchProductionSteps();

  }, []);

  // =====================================
  // OUTSIDE CLICK
  // =====================================

  useEffect(() => {

    const handleClickOutside = (
      event
    ) => {

      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(
          event.target
        )
      ) {

        setDropdownOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };

  }, []);

  // =====================================
  // HANDLE CHANGE
  // =====================================

  const handleChange = (e) => {

    const { name, value } =
      e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =====================================
  // SELECT PRODUCT
  // =====================================

  const handleSelectProduct = (
    product
  ) => {

    const exists =
      selectedProducts.find(
        (p) => p._id === product._id
      );

    if (exists) {

      setSelectedProducts(
        selectedProducts.filter(
          (p) => p._id !== product._id
        )
      );

    } else {

      setSelectedProducts([
        ...selectedProducts,
        product,
      ]);
    }
  };

  // =====================================
  // SAVE
  // =====================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    // if (!form.processName) {

    //   return swal(
    //     "Error",
    //     "Enter Process Name",
    //     "error"
    //   );
    // }

    if (!form.step_Name) {

      return swal(
        "Error",
        "Enter Step Name",
        "error"
      );
    }

    // if (
    //   selectedProducts.length === 0
    // ) {

    //   return swal(
    //     "Error",
    //     "Select Products",
    //     "error"
    //   );
    // }

    try {

      setLoading(true);

      const payload = {

        processName:
          form.processName,

        steps: [
          {
            note: form.note,

            step_Name:
              form.step_Name,

            step_No: Number(
              form.step_No
            ),

            products:
              selectedProducts.map(
                (p) => ({
                  productId: p._id,
                  productName:
                    p.Product_Title,
                })
              ),
          },
        ],

        createdBy:
          user?._id,

        database:
          user?.database,
      };

      console.log(
        "PAYLOAD =>",
        payload
      );

      const res =
        await axiosConfig.post(
          "/production-step/add-step",
          payload
        );

      if (res?.data?.status) {

        swal(
          "Success",
          "Production Step Added",
          "success"
        );

        fetchProductionSteps();

        setForm({
          processName: "",
          note: "",
          step_Name: "",
          step_No: "",
        });

        setSelectedProducts([]);
      }

    } catch (err) {

      console.log(err);

      swal(
        "Error",
        "Something Went Wrong",
        "error"
      );

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // LOADING
  // =====================================
  // =====================================
  // DELETE STEP
  // =====================================

  const handleDelete = async (id) => {

    swal(
      "Warning",
      "Sure You Want To Delete?",
      {
        buttons: {
          cancel: "Cancel",
          delete: {
            text: "Delete",
            value: "delete",
          },
        },
      }
    ).then(async (value) => {

      if (value === "delete") {

        try {

          const res =
            await axiosConfig.delete(
              `/production-step/delete-steps/${id}`
            );

          if (res?.data?.status) {

            swal(
              "Success",
              "Step Deleted Successfully",
              "success"
            );

            // TABLE REFRESH
            fetchProductionSteps();

          } else {

            swal(
              "Error",
              "Delete Failed",
              "error"
            );
          }

        } catch (err) {

          console.log(err);

          swal(
            "Error",
            "Something Went Wrong",
            "error"
          );
        }
      }
    });
  };
  if (loading) {

    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "100px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div className="erp-page-grid">

      <Card>

        <CardBody>

          <h3>
            Production Steps
          </h3>

          {/* ================================= */}
          {/* FORM */}
          {/* ================================= */}

          <form onSubmit={handleSubmit}>

            <Row>

              {/* PROCESS NAME */}
              {/* 
              <Col md="3">

                <label>
                  Process Name
                </label>

                <Input
                  type="text"
                  name="processName"
                  value={
                    form.processName
                  }
                  onChange={
                    handleChange
                  }
                />

              </Col> */}

              {/* STEP NAME */}

              <Col md="3">

                <label>
                  Step Name
                </label>

                <Input
                  type="text"
                  name="step_Name"
                  value={
                    form.step_Name
                  }
                  onChange={
                    handleChange
                  }
                />

              </Col>

              {/* STEP NO */}

              <Col md="2">

                <label>
                  Step No
                </label>

                <Input
                  type="number"
                  name="step_No"
                  value={
                    form.step_No
                  }
                  onChange={
                    handleChange
                  }
                />

              </Col>

              {/* NOTE */}

              {/* <Col md="4">

                <label>
                  Note
                </label>

                <Input
                  type="text"
                  name="note"
                  value={form.note}
                  onChange={
                    handleChange
                  }
                />

              </Col> */}
              <Col md="4">

                <label>
                  Products
                </label>

                <div
                  ref={dropdownRef}
                  style={{
                    position:
                      "relative",
                  }}
                >

                  {/* SELECT BOX */}

                  <div
                    onClick={() =>
                      setDropdownOpen(true)
                    }
                    style={{
                      border:
                        "1px solid #ced4da",

                      minHeight:
                        "38px",

                      borderRadius:
                        "6px",

                      padding: "6px",

                      background:
                        "#fff",

                      cursor:
                        "pointer",
                    }}
                  >

                    {selectedProducts.length >
                      0 ? (

                      <div
                        style={{
                          display:
                            "flex",

                          flexWrap:
                            "wrap",

                          gap: "5px",
                        }}
                      >

                        {selectedProducts.map(
                          (item) => (

                            <Badge
                              key={item._id}
                              color="primary"
                            >
                              {
                                item.Product_Title
                              }
                            </Badge>
                          )
                        )}

                      </div>

                    ) : (

                      <span>
                        Select Products
                      </span>

                    )}

                  </div>

                  {/* DROPDOWN */}

                  {dropdownOpen && (

                    <div
                      style={{
                        position:
                          "absolute",

                        width:
                          "100%",

                        background:
                          "#fff",

                        border:
                          "1px solid #ddd",

                        borderRadius:
                          "6px",

                        marginTop:
                          "5px",

                        maxHeight:
                          "250px",

                        overflowY:
                          "auto",

                        zIndex:
                          9999,

                        padding:
                          "10px",
                      }}
                    >

                      {allProducts.map(
                        (product) => {

                          const checked =
                            selectedProducts.some(
                              (p) =>
                                p._id ===
                                product._id
                            );

                          return (

                            <div
                              key={
                                product._id
                              }
                              style={{
                                padding:
                                  "5px 0",
                              }}
                            >

                              <Input
                                type="checkbox"
                                checked={
                                  checked
                                }
                                onChange={() =>
                                  handleSelectProduct(
                                    product
                                  )
                                }
                              />

                              {" "}

                              {
                                product.Product_Title
                              }

                            </div>
                          );
                        }
                      )}

                    </div>
                  )}

                </div>

              </Col>
            </Row>

            <br />

            <Button
              color="primary"
              type="submit"
            >
              Save
            </Button>

          </form>

          {/* ================================= */}
          {/* TABLE */}
          {/* ================================= */}

          <hr />

          <Table
            bordered
            responsive
          >

            <thead>

              <tr>

                <th>#</th>

                {/* <th>
                  Process Name
                </th> */}

                <th>
                  Step Name
                </th>

                <th>
                  Step No
                </th>
                {/* 
                <th>
                  Note
                </th> */}

                <th>
                  Products
                </th>
                <th>
                  Action
                </th>
              </tr>

            </thead>

            <tbody>

              {tableData.length > 0 ? (

                tableData.map((item, index) => (

                  item.steps?.map((step, stepIndex) => (

                    <tr
                      key={`${item._id}-${step._id}`}
                    >

                      <td>
                        {index + 1}.{stepIndex + 1}
                      </td>

                      {/* <td>
            {item.processName || "-"}
          </td> */}

                      <td>
                        {step?.step_Name}
                      </td>

                      <td>
                        {step?.step_No}
                      </td>

                      {/* <td>
            {step?.note || "-"}
          </td> */}

                      <td>

                        {step?.products?.length > 0 ? (

                          step.products.map(
                            (p, i) => (

                              <Badge
                                key={i}
                                color="info"
                                className="me-1"
                              >
                                {p.productName}
                              </Badge>
                            )
                          )

                        ) : (

                          "-"
                        )}

                      </td>
                      <td>

                        <Button
                          color="danger"
                          size="sm"
                          onClick={() =>
                            handleDelete(step?._id)
                          }
                        >
                          Delete
                        </Button>

                      </td>
                    </tr>
                  ))
                ))

              ) : (

                <tr>

                  <td
                    colSpan="6"
                    className="text-center"
                  >
                    No Data Found
                  </td>

                </tr>
              )}

            </tbody>

          </Table>

        </CardBody>

      </Card>

    </div>
  );
}